import { call, select, put } from "redux-saga/effects";
import API from "../../API";
import {
  loadResponsesInfoError, loadResponsesInfoSuccess, loadTopWordsError,
  loadTopWordsSuccess
} from "./charts-action-creators";
import {mapPercent} from "../../utilities/mapPercent";
import deepCopy from "../../utilities/deepCopy";
import {paginate} from "./functions";
import {loadTopWordsPaginated} from "../full-report-top-words/full-report-top-words-action-creators";


export function* loadTopWordsRequest() {

  const reportUrl = yield select(state => state.report.reportUrl);
  const filters = yield select(state => state.filters.filtersToSend);
  try {
    const result = yield call(API.loadTopWords, {reportUrl, filters});
    console.log(filters, 'FILTERS FROM LOAD TOP WORDS REQUEST');
    console.log(result, 'RESULT FROM LOAD TOP WORDS REQUEST');

    if (result.data.results && result.data.results.length) {
      const { topWords, topWordsPaginated} = normalizeTopWords({
        topWords: result.data.results
      });
      yield put(loadTopWordsSuccess(topWords));
      yield put(loadTopWordsPaginated(topWordsPaginated));
      yield put(loadResponsesInfoSuccess({
        responsesTotal: result.data.responses_total,
        responsesAfter: result.data.responses_after_meta_filter
      }))
    } else {
      yield put(loadTopWordsError("No data"));
      yield put(loadResponsesInfoError("No data"));
    }
  } catch(error) {
    console.log(error, 'ERROR FROM LOAD TOP WORDS REQUEST');
    yield put(loadTopWordsError("Something went wrong..."));
    yield put(loadResponsesInfoError("Something went wrong..."))
  }
}

const normalizeTopWords = ({topWords}) => {
  let short = deepCopy(topWords.filter((word, i) => i < 9));
  const other = topWords.reduce((acc, current, currentIndex) => {
    if (currentIndex >= 9) {
      acc.count += current.count;
      return acc;
    }
    return acc;
  }, {term: 'other emotional words', count: 0});
  short.push(other);
  mapPercent(short);
  short.sort((a, b) => b.count - a.count);
  let full = deepCopy(topWords);
  mapPercent(full);
  full = paginate(full, 15);
  return {
    topWords: short,
    topWordsPaginated: full
  };
};


// WEBPACK FOOTER //
// ./src/modules/charts/load-top-words-saga.js